import { CurrencyId } from "@/services/currencies/currenciesTypes";
import { type ApiResponseImage, type ApiResponseImageNoId } from "@/services/images";
import { type PriceNumeric } from "@/services/prices";
import { type DateTimeObject } from "@/utilities";
import { faker } from "@faker-js/faker";

export const mockApiResponse = async <T>(response: T): Promise<T> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(response);
    }, 2000);
  });
};

export const mockDateTime = (inThePast = true): string => {
  const dateTime = inThePast ? faker.date.past() : faker.date.anytime();

  return `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(2, "0")}-${String(dateTime.getDate()).padStart(2, "0")} ${String(dateTime.getHours()).padStart(2, "0")}:${String(dateTime.getMinutes()).padStart(2, "0")}:${String(dateTime.getSeconds()).padStart(2, "0")}`;
};

export const mockDateObject = (inThePast = true): DateTimeObject => new Date(mockDateTime(inThePast));

export const mockPrice = (currencyId: CurrencyId = CurrencyId.Czk): PriceNumeric => ({ price: parseFloat(faker.commerce.price()), currencyId });

export const mockImage = (): ApiResponseImageNoId | null => {
  const img = faker.image.urlPicsumPhotos({ width: 400, height: 300, blur: 0 }); // use same image (with same resolution for all image variants)

  return (
    faker.helpers.maybe(
      () => ({
        imageUrl: {
          "85x64": { jpeg: img, webp: img, avif: img },
          "310x233": { jpeg: img, webp: img, avif: img },
          "467x350": { jpeg: img, webp: img, avif: img },
          "1200x900": { jpeg: img, webp: img, avif: img },
          "1600x1200": { jpeg: img, webp: img, avif: img },
        },
      }),
      { probability: 0.9 }
    ) ?? null
  );
};

export const mockImageWithId = (): ApiResponseImage | null => {
  const img = mockImage();
  if (img === null) {
    return null;
  } else {
    return {
      id: faker.number.int(),
      ...img,
    };
  }
};

export const mockCzechBankAccountNumber = (): string => {
  const bankCodes = ["2070", "3030", "6100"]; // not exhaustive—extend as you like

  const prefixLen = faker.number.int({ min: 0, max: 6 });
  const prefix = prefixLen === 0 ? "" : faker.string.numeric(prefixLen) + "-";

  const baseLen = faker.number.int({ min: 2, max: 10 });
  const base = faker.string.numeric(baseLen);

  const bankCode = faker.helpers.arrayElement(bankCodes);

  return `${prefix}${base}/${bankCode}`;
};

export const mockIban = (): string => {
  return faker.finance.iban();
};
